import React from 'react';
import Helmet from 'react-helmet';
import Layout from '../../Layout/layout';
import VideoUsage from './VideoUsage';

export default function VideoUsageReport() {
  return <Layout><Helmet><title>Customer Video Usage</title></Helmet><div className="contentBody"><div className="contentWrapper"><VideoUsage standalone /></div></div></Layout>;
}
